var map = {
	"./CUIABA/diariobg.jpg": "1yyV",
	"./PMVG/diariobg.jpg": "HqUf",
	"./TCE-AL/diariobg.jpg": "Jh4b"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YKlk";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens ^\.\/.*\/diariobg\.jpg$
// module id = YKlk
// module chunks = 1